function handlePDPBundleOptionChange() {
  const productForm = document.querySelector('.shopify-product-form');

  if (productForm) {
    if (productForm.getAttribute('data-product-form') && productForm.getAttribute('data-product-form').includes('bundle')) {
      const variantOptions = document.querySelectorAll('.variant-option');

      variantOptions.forEach((variantOption) => {
        const variantRadios = variantOption.querySelectorAll('.variant-option__radio');

        variantRadios.forEach((radio) => {
          radio.addEventListener('change', function (event) {
            const variantOptionSpan = variantOption.querySelector('.variant-option__value');

            if (variantOptionSpan) {
              variantOptionSpan.textContent = event.target.value;
            }
          });
        });
      });
    }
  }
}

function checkAndSelectAvailableUpsellVariant() {
    const selectElements = document.querySelectorAll('[data-upsell-option-selector]');
  
    selectElements.forEach(select => {
        const options = Array.from(select.options);
        let selectedOption = select.selectedOptions[0];
    
        options.forEach(option => {
            if (option.getAttribute('data-variant-available') !== 'true') {
                option.remove();
            }
        });
    
        const isSelectedAvailable = selectedOption && selectedOption.parentNode && selectedOption.getAttribute('data-variant-available') === 'true';
    
        if (!isSelectedAvailable && select.options.length > 0) {
            select.selectedIndex = 0;
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
}

function initializeMinicartUpsellObserver() {
    function observeCartChanges() {
        const cartContainer = document.querySelector('.minicart');
        if (!cartContainer) return;

        const cartObserver = new MutationObserver(() => {
            checkAndSelectAvailableUpsellVariant();
        });

        cartObserver.observe(cartContainer, {
            childList: true,
            subtree: true,
        });
    }

    const upsellContainer = document.querySelector('.minicart__upsells');
    if (upsellContainer) {
        checkAndSelectAvailableUpsellVariant();
    }

    const observer = new MutationObserver(() => {
        const upsellElements = document.querySelector('.minicart__upsells');
        if (upsellElements) {
            observer.disconnect();
            checkAndSelectAvailableUpsellVariant();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    observeCartChanges();
}

document.addEventListener("DOMContentLoaded", function () {
  /* PDP bundle option header change */
  handlePDPBundleOptionChange();

  /* cart drawer upsell not available options removal */
  initializeMinicartUpsellObserver();

  /* benefits image change on variation select */
  let productData = null;
  const productJsonElement = document.getElementById(`ProductJson-${window.ShopifyAnalytics?.meta?.product?.id || ''}`);
  
  if (productJsonElement) {
      try {
          productData = JSON.parse(productJsonElement.textContent);
  
          window.variantMap = {};
          productData.variants.forEach(variant => {
              window.variantMap[variant.title] = variant;
  
              if (variant.metafields?.custom?.benefits_center_image_variants) {
                  let url = variant.metafields.custom.benefits_center_image_variants;
                  if (typeof url === 'string' && url.startsWith('//')) {
                      variant.metafields.custom.benefits_center_image_variants = 'https:' + url;
                  }
              }
          });
      } catch (e) {
          console.error('Error parsing product JSON:', e);
      }
  }
  
  let currentSelectedVariant = null;
  
  const variantRadios = document.querySelectorAll('.variant-option__radio');
  
  variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
          if (radio.checked) {
              currentSelectedVariant = radio.value;
              updateImages();
          }
      });
  });
  
  function getCurrentVariantImageUrl() {
      if (!currentSelectedVariant || !window.variantMap || !window.variantMap[currentSelectedVariant]) {
          return null;
      }
  
      const variant = window.variantMap[currentSelectedVariant];
  
      if (variant.metafields?.custom?.benefits_center_image_variants) {
          return variant.metafields.custom.benefits_center_image_variants;
      }
  
      if (variant.featured_image) {
          return typeof variant.featured_image === 'string' ?
              variant.featured_image : variant.featured_image.src;
      }
  
      return null;
  }
  
  function updateImages() {
      const imageUrl = getCurrentVariantImageUrl();
      if (!imageUrl) return;
  
      const imageContainer = document.querySelector('.full-width-benefits__image');
      if (!imageContainer) return;
  
      updateSpecificImage(
          imageContainer.querySelector('.image-snippet__img--desktop'),
          imageUrl,
          266, 460
      );
  
      updateSpecificImage(
          imageContainer.querySelector('.image-snippet__img--tablet'),
          imageUrl,
          173, 300
      );
  
      updateSpecificImage(
          imageContainer.querySelector('.image-snippet__img--mobile'),
          imageUrl,
          115, 200
      );
  }
  
  function updateSpecificImage(imgElement, imageUrl, width, height) {
      if (!imgElement || !imageUrl) return;
  
      try {
          let baseUrl = imageUrl;
          let version = '';
          const questionMarkIndex = imageUrl.indexOf('?');
  
          if (questionMarkIndex !== -1) {
              baseUrl = imageUrl.substring(0, questionMarkIndex);
              const vMatch = imageUrl.match(/[?&]v=([^&]*)/);
              if (vMatch) version = vMatch[1];
          }
  
          const placeholderWidth = Math.max(1, Math.round(width / 10));
          const placeholderHeight = Math.max(1, Math.round(height / 10));
  
          const placeholderUrl = `${baseUrl}?crop=center&height=${placeholderHeight}&${version ? 'v=' + version + '&' : ''}width=${placeholderWidth}`;
          const fullSizeUrl = `${baseUrl}?crop=center&height=${height}&${version ? 'v=' + version + '&' : ''}width=${width}`;
          const doubleWidth = width * 2;
          const doubleHeight = height * 2;
          const doubleSizeUrl = `${baseUrl}?crop=center&height=${doubleHeight}&${version ? 'v=' + version + '&' : ''}width=${doubleWidth}`;
  
          imgElement.dataset.expectedBenefitImage = fullSizeUrl;
  
          if (imgElement.getAttribute('loading') === 'lazy') {
              if (imgElement.src !== placeholderUrl) {
                  imgElement.src = placeholderUrl;
              }
          } else {
              if (imgElement.src !== fullSizeUrl) {
                  imgElement.src = fullSizeUrl;
              }
          }
  
          const expectedSrcset = `${fullSizeUrl} ${width}w, ${doubleSizeUrl} ${doubleWidth}w`;
          if (imgElement.srcset !== expectedSrcset) {
              imgElement.srcset = expectedSrcset;
          }
      } catch (e) {
          console.error('Error updating specific image:', e);
      }
  }
  
  const benefitsContainer = document.querySelector('.full-width-benefits__image');
  if (benefitsContainer) {
      const observer = new MutationObserver(function(mutations) {
          let needsUpdate = false;
  
          mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes') {
                  const target = mutation.target;
                  if (target.tagName === 'IMG' && (mutation.attributeName === 'src' || mutation.attributeName === 'srcset')) {
                      if (target.dataset.expectedBenefitImage &&
                          ((mutation.attributeName === 'src' && !target.src.includes(target.dataset.expectedBenefitImage)) ||
                              (mutation.attributeName === 'srcset' && !target.srcset.includes(target.dataset.expectedBenefitImage)))) {
                          needsUpdate = true;
                      }
                  }
              }
          });
  
          if (needsUpdate) {
              observer.disconnect();
  
              updateImages();
  
              observer.observe(benefitsContainer, {
                  attributes: true,
                  attributeFilter: ['src', 'srcset'],
                  subtree: true
              });
          }
      });
  
      observer.observe(benefitsContainer, {
          attributes: true,
          attributeFilter: ['src', 'srcset'],
          subtree: true
      });
  }
});
